import React from 'react';
import { t } from '@lingui/macro';
import { Box, Image } from '@landr/maestro';
import { getImageUrl } from 'helpers';

export const SamplePackArtwork: React.FC<{
    sampleUrl: string;
    samplePackName: string;
}> = ({ sampleUrl, samplePackName }) => (
    <Box
        width="md"
        height="md"
        borderRadius="sm"
        backgroundColor="surface.medium"
    >
        <Image
            width="100%"
            height="100%"
            borderRadius="sm"
            src={sampleUrl && getImageUrl({ imageUrl: sampleUrl, width: 36 })}
            loading="lazy"
            fallbackSrc={`${
                import.meta.env.BASE_URL
            }assets/fallback/artworkPlaceholder.svg`}
            alt={t`Cover of ${samplePackName}`}
        />
    </Box>
);
